import { graphql } from "src/graphql/generated";

export const resetPasswordMutation = graphql(/* GraphQL */ `
    mutation ResetPassword($email: String!) {
        resetPassword(email: $email)
    }
`);
